export default __webpack_public_path__ + "static/media/ImgenChicaExplicando.e768f6f4.png";